/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:const
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/02 | 富士通株式会社         | 新規作成
// 01.01.00 | 2022/10/11 | 富士通Japan株式会社    | 令和4年度改修対応（2次リリース）
// 01.02.00 | 2023/02/13 | 富士通Japan株式会社    | 令和4年度改修対応（3次リリース）
// 01.03.00 | 2023/04/26 | 富士通Japan株式会社    | 令和5年度改修対応（1次リリース）
// 01.04.00 | 2023/11/01 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
 */
// テキスト入力項目の書式
export const TEXTINPUT_TYPE = {
    ALL: 1, // 全て
    FULL: 2, // 全角
    HIRAGANA: 3, // 全角ひらがな
    HALF: 4, // 半角
    HALF_KANA: 5, // 半角カナ
    HALF_ALPHA_NUM: 6, // 半角英数
    HALF_NUM: 7, // 半角数字
    E_MAIL: 8 // e-mail
};

// 数値入力項目の書式
export const NUMBERINPUT_TYPE = {
    INTEGER: '1', // 整数値
    NON_PERIOD: '2', // 桁区切りなし（例：1234）
    PERIOD: '3', // 桁区切りあり（例：1,234）
}

// ダイアログボタン
export const DIALOG_BUTTON_LIST_KEY = {
    OK: 'ok', // OK
    CANCEL: 'cancel', // CANCEL
    ESC: 'esc', // ESC
};

// ダイアログ種別
export const DIALOG_KIND = {
    NOTICE: 1, // 通知用ダイアログ
    CONFIRM: 2, // 確認用ダイアログ
    ALERT: 3, // 警告用ダイアログ
};

// 桁数
//--郵便番号
export const MAX_LENGTH_POSTAL_CODE = 8;
//--電話番号
export const MAX_LENGTH_PHONE_NUMBER = 15;

// HTTPステータスコード
export const HTTP_STATUS = {
    OK: '200', // リクエストは成功しレスポンスとともに要求に応じたリソースが返される
    CREATED: '201', // リクエストは完了し新たにリソースが作成、更新された
    NO_CONTENT: '204', // リクエストを受理したが、返すべきレスポンスエンティティが存在しない場合に返される
    BAD_REQUEST: '400', // バリデーションエラー、存在確認チェックのエラーとなった場合に返される
    UNAUTHORIZED: '401', // 認証時に認証エラーとなった場合に返される
    FORBIDDEN: '403', // リソースへのアクセス権限がない場合に返される
    NOT_FOUND: '404', // リソースが見つからなかった (ページが見つからなかった)
    CONFLICT: '409', // 作成しようとしたリソースが既にある場合に返される。削除しようとしたリソースがロック中(悲観)の場合に返される
    INTERNAL_SERVER_ERROR: '500' // サーバ内部にエラーが発生した場合に返される。主にシステムエラーとなる
}


export const FILE_SIZE = {
    ONE_MB: 1048576 // 1MByte
};

// カスタムコントロールのコード種類
export const CD_HANDLE_TYPE = {
    ID_CD: '0', // コード値
    CD_HANYO1: '1', // 汎用コード１
    CD_HANYO2: '2', // 汎用コード２
    CD_HANYO3: '3', // 汎用コード３
    MIX_HANYO21: '4', // 汎用コード２ + 汎用コード１
    MIX_CD_HANYO1: '5' // コード値 + 汎用コード１
}

// ロール名の種類
export const ROLE_TYPE = {
    IPPAN_RIYOUSYA: '1', // 利用者用
    TOKYOTO_STAFF: '2' // 東京都担当者用
}

// 年月日の種類
export const DATE_KIND = {
    BIRTHDAY: 0, // 誕生日
    KINMU_START: 1, // 勤務（開業）開始日
    ZAIRYU_FROM: 2, // 在留期間（自）
    ZAIRYU_TO: 3, // 在留期間（至）
    KOKAI_START: 4, // 公開開始日
    KOKAI_END: 5, // 公開終了日
    HENKO_HANEI: 6, // 変更反映日
    MOUSIKOMI_FROM: 7, // 申込日（自）
    MOUSIKOMI_TO: 8, // 申込日（至）
    TECYO_KIGEN: 9, // 精神障害者福祉手帳の期限
    KADO_DATE: 10, // 稼働日付
}

// 年月日時分の種類
export const DATETIME_KIND = {
    KOKAI_START: 1, // 公開開始日時
    KOKAI_END: 2, // 公開終了日時
    HENKO_HANEI: 3, // 変更反映日時
}

// 年月の種類
export const YEAR_MONTH_KIND = {
    KOBO: 0, // 公募年月
    KOBO_MOUSIKOMI: 1, // 公募年月（申込履歴検索・一覧画面（管理者用））
}

// 並び替えの種類
export const SORT_KIND = {
    NORMAL: 1, // 毎月募集、定期募集
    ZUIJI: 2, // 随時募集
    KANRI: 3, // 随時募集（住宅メンテ）
    OKINIIRI: 4, // お気に入り登録した住宅検索
}

// 募集住宅情報（随時募集）
export const ZUIJI_JYUTAKU = 'ZUIJI_JYUTAKU';

// 全角ハイフン
export const ZENKAKU_HYPHEN = '－';

// 生年月日の西暦初期値
export const DATE_BIRTHDAY_YYYY_INIT = '1970';

// 成年者基準年齢
export const SEINENSYA_KIJUN_AGE = 18;

// 在留資格注意文非表示対象の住宅の種別コード
export const SINGLE_ZYUTAKU_SYUBETU = ['07', '08', '09', '10', '11', '12', '14', '15', '18', '20'];

// 募集方式の種類
export const BOSYU_HOSHIKI = {
    MAITUKI: '1',       // 毎月募集
    TEIKI_TYUSEN: '2',  // 定期募集（抽せん方式）
    TEIKI_POINT: '3',   // 定期募集（ポイント方式）
    ZUIJI: '4'          // 随時募集
}